import React from "react";
import Select from "react-select";

/**
 * Generic reusable filter component
 *
 * filters = [
 *   {
 *     key: "farmerId",
 *     type: "select",
 *     placeholder: "Search Farmer",
 *     options: [],
 *     value: 0,
 *     onChange: fn
 *   },
 *   {
 *     key: "month",
 *     type: "month",
 *     value: "2026-01",
 *     onChange: fn
 *   }
 * ]
 */

export default function CommonFilter({
  filters = [],
  loading = false,
  onClear,
}) {
  return (
    <div className="filters">
      <div className="filters-content">
        <div className="filter-row">

          {filters.map((f) => {
            // 🔹 SELECT (Searchable)
            if (f.type === "select") {
              return (
                <div className="filter-group" key={f.key}>
                  <Select
                    //className="filter-select"
                    classNamePrefix="react-select"
                    placeholder={f.placeholder}
                    isClearable
                    isDisabled={loading}
                    options={f.options}
                    value={
                      f.options.find(x => x.value === f.value) || null
                    }
                    onChange={(opt) =>
                      f.onChange(opt ? opt.value : 0)
                    }
                  />
                </div>
              );
            }

            // 🔹 MONTH
            if (f.type === "month") {
              return (
                <div className="filter-group" key={f.key}>
                  <input
                    type="month"
                    value={f.value}
                    onChange={(e) => f.onChange(e.target.value)}
                    className="date-input"
                  />
                </div>
              );
            }

            // 🔹 DATE
            if (f.type === "date") {
              return (
                <div className="filter-group" key={f.key}>
                  <input
                    type="date"
                    value={f.value}
                    onChange={(e) => f.onChange(e.target.value)}
                    className="date-input"
                  />
                </div>
              );
            }

            return null;
          })}

          {onClear && (
            <div className="filter-actions">
              <button
                type="button"
                className="clear-filters-btn"
                onClick={onClear}
                disabled={loading}
              >
                Clear
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
